module.exports = __webpack_public_path__ + "static/img/nuevos.7acca211.jpg";